import AlternativeChildrenCategory from './AlternativeChildrenCategory';

export default AlternativeChildrenCategory;